import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// 🔥 HARD FIX: CHẶN BACK/FORWARD CACHE
window.addEventListener('pageshow', function (event) {
  const user = localStorage.getItem('user');

  // nếu load lại từ cache (back/forward)
  if (event.persisted || window.performance.navigation.type === 2) {
    if (!user) {
      window.location.replace('/login');
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();